import { getEnumValues } from "sprint-common-web";

export enum OrderProxyType {
    H264 = 1,
    Aac128k = 2,
    Aac48k = 3,
    Mp2 = 4,
    AacFdk128k = 5,
    AacFdk48k = 6,
    AacFdkHev264k = 7,
    Mp2_128k48 = 8,
    AacFdk128k48 = 9
}

export const mapNumberToOrderProxyType = (typeNumber: number): OrderProxyType => {
    if (isNumberOrderProxyType(typeNumber)) {
        return typeNumber;
    }

    throw new Error("Incorrect ProxyType");
};

const isNumberOrderProxyType = (typeNumber: number) => {
    const proxyTypes = getEnumValues(OrderProxyType);

    return proxyTypes.some((proxy: OrderProxyType) => proxy === typeNumber);
};
